// Localhost
export const LOCALHOST = process.env.REACT_APP_URL_LOCAL;

// Auth
export const SIGNIN = '/';

export const EXPIRATIONTOKEN = '/expirationtoken';

export const PAGENOTFOUND = '/*';

// Home
export const HOME = '/home';

// Users
export const USERS = '/users';
export const USERLIST = '/users/list';
export const USERNEW = '/users/new';
export const USEREDIT = '/users/edit';

// Chat
export const CHATVIDEO = '/videocall';
export const CHAT = '/chat';
export const PQRWEB = '/pqr-web';
export const PQRWEB_SEARCH = '/pqr-web/search';
export const PQRWEB_CREATE = '/pqr-web/create';
export const PQRWEB_SURVEY = '/pqr-web/survey';
export const PQRWEB_SURVEY_RESPONSE = '/pqr-web/survey/response';

// Update channels SMS Form
export const CHANNELSSMSFORM = '/channels-web';
export const CHANNELSMSFORMTHANKYOU = '/channels-web/thank-you';

// Export
export const EXPORT = '/export';

// Modules
export const MODULES = '/modules';
export const ACCOUNTS = `${MODULES}/accounts`;
export const ACCOUNTS_DETAIL = `${ACCOUNTS}/detail`;
export const ACCOUNTS_NEW = `${ACCOUNTS}/new`;
export const ACCOUNTS_EDIT = `${ACCOUNTS}/edit`;
export const PQR = `${MODULES}/pqr`;
export const PQR_DETAIL = `${PQR}/detail`;
export const PQR_HISTORY = `${PQR}/history`;
export const PQR_NEW = `${PQR}/new`;
export const PQR_EDIT = `${PQR}/edit`;
export const PQR_SURVEY_DETAIL = `${PQR}/survey-detail`;

export const SARLAFT = `${MODULES}/sarlaft`;
export const SARLAFT_DETAIL = `${SARLAFT}/detail`;
export const SARLAFT_EDIT = `${SARLAFT}/edit`;
export const GENERAL = `${MODULES}/accounts`;
export const SEARCH_CASE = `${MODULES}/pqr`;
export const CASES_GENERAL_INFORMATION = `${MODULES}/general-case-info`;
export const CASES_GENERAL_INFORMATION_DETAIL = `${CASES_GENERAL_INFORMATION}/detail`;
export const CASES_GENERAL_INFORMATION_EDIT = `${CASES_GENERAL_INFORMATION}/edit`;
export const CASES_GENERAL = `${MODULES}/cases-general`;
// export const CASES_GENERAL_CREATE = `${MODULES}/cases-general/create`;
export const CASES_GENERAL_DETAIL = `${CASES_GENERAL}/detail`;
export const CASES_GENERAL_EDIT = `${CASES_GENERAL}/edit`;

// PQR Management
export const PQR_MANAGEMENT = '/pqr-management';
export const LEGAL_PROCEEDINGS = `${PQR_MANAGEMENT}/legal-proceedings`;
export const LEGAL_PROCEEDINGS_NEW = `${LEGAL_PROCEEDINGS}/new`;
export const LEGAL_PROCEEDINGS_EDIT = `${LEGAL_PROCEEDINGS}edit`;
export const LEGAL_PROCEEDINGS_DETAIL = `${LEGAL_PROCEEDINGS}detail`;
export const ALERTS = `${PQR_MANAGEMENT}/alerts`;
export const ALERTS_NEW = `${ALERTS}/new`;
export const ALERTS_EDIT = `${ALERTS}/edit`;
export const ALERTS_DETAIL = `${ALERTS}/detail`;
export const SAMPLES = `${PQR_MANAGEMENT}/pqr-samples`;
export const SAMPLES_EDIT = `${SAMPLES}/edit`;
export const SAMPLES_DETAIL = `${SAMPLES}/detail`;

// Typifications
export const TYPIFICATIONS = '/typifications';
export const FINAL_CAUSALITY = `${TYPIFICATIONS}/final-causality`;
export const FINAL_CAUSALITY_NEW = `${FINAL_CAUSALITY}/new`;
export const FINAL_CAUSALITY_EDIT = `${FINAL_CAUSALITY}/edit`;
export const FINAL_CAUSALITY_DETAIL = `${FINAL_CAUSALITY}/detail`;

export const INITIAL_CAUSALITY = `${TYPIFICATIONS}/initial_causality`;
export const INITIAL_CAUSALITY_DETAIL = `${INITIAL_CAUSALITY}/detail`;
export const INITIAL_CAUSALITY_NEW = `${INITIAL_CAUSALITY}/new`;
export const INITIAL_CAUSALITY_EDIT = `${INITIAL_CAUSALITY}/edit`;

// System Config
export const SYSTEMCONFIG = '/config';
export const REDIRECT = `${SYSTEMCONFIG}/redirect`;
export const REDIRECTLIST = `${SYSTEMCONFIG}/redirect/list`;
export const REDIRECTNEW = `${SYSTEMCONFIG}/redirect/new`;
export const REDIRECTEDIT = `${SYSTEMCONFIG}/redirect/edit`;
export const REDIRECT_DETAIL = `${SYSTEMCONFIG}/redirect/detail`;

export const MOTIVE = `${SYSTEMCONFIG}/motive`;
export const MOTIVE_NEW = `${SYSTEMCONFIG}/motive/new`;
export const MOTIVE_EDIT = `${SYSTEMCONFIG}/motive/edit`;
export const MOTIVE_DETAIL = `${SYSTEMCONFIG}/motive/detail`;
